import { render } from "./ProductSubscriptionListComponent.vue?vue&type=template&id=2ef4aa04"
import script from "./ProductSubscriptionListComponent.vue?vue&type=script&lang=js"
export * from "./ProductSubscriptionListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__